import { useState } from 'react';
import { extApi } from '../api/extensibilityClient';

export function SubModelBuilderPage() {
  const [form, setForm] = useState({
    name: '', description: '', frequency: 'annual', output_variable_id: '',
    inputs: '', equation: 'output = x * beta', param_beta: '1',
  });
  const [msg, setMsg] = useState<string | null>(null);

  const submit = async () => {
    const inputs = form.inputs.split(',').map((s) => s.trim()).filter(Boolean);
    const r = await extApi.createSubModel({
      name: form.name,
      description: form.description,
      frequency: form.frequency,
      active: false,
      output_variable_id: form.output_variable_id || undefined,
      inputs,
      equations: form.output_variable_id ? [{ output_variable_id: form.output_variable_id, formula_expression: form.equation }] : [],
      parameters: [{ param_key: 'beta', param_value: parseFloat(form.param_beta), unit: 'elasticity' }],
      change_note: 'Initial version',
    }) as { id: string; version: number };
    setMsg(`Created sub-model ${r.id} (v${r.version}) — activate after testing`);
  };

  return (
    <div>
      <h1 className="page-title">Sub-Model Builder</h1>
      <p className="page-subtitle">Inputs → Equations → Outputs → downstream linkages. Versioned revisions.</p>
      <div className="card" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <label style={{ fontSize: '0.85rem' }}>Name<input className="field" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></label>
        <label style={{ fontSize: '0.85rem' }}>Frequency<input className="field" value={form.frequency} onChange={(e) => setForm({ ...form, frequency: e.target.value })} /></label>
        <label style={{ fontSize: '0.85rem' }}>Output variable ID<input className="field" value={form.output_variable_id} onChange={(e) => setForm({ ...form, output_variable_id: e.target.value })} /></label>
        <label style={{ fontSize: '0.85rem' }}>Input variables (comma-separated)<input className="field" value={form.inputs} onChange={(e) => setForm({ ...form, inputs: e.target.value })} /></label>
        <label style={{ fontSize: '0.85rem' }}>Equation<textarea className="field" rows={2} value={form.equation} onChange={(e) => setForm({ ...form, equation: e.target.value })} /></label>
        <label style={{ fontSize: '0.85rem' }}>Parameter β<input className="field" value={form.param_beta} onChange={(e) => setForm({ ...form, param_beta: e.target.value })} /></label>
      </div>
      <p style={{ fontSize: '0.85rem', color: '#6b7280' }}>{form.description || 'Describe purpose in notes when saving.'}</p>
      <button className="btn" type="button" onClick={submit}>Create sub-model (inactive)</button>
      {msg && <p style={{ color: '#16a34a', marginTop: '0.75rem' }}>{msg}</p>}
    </div>
  );
}
